var _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g7, _g8, _g9, _g10, _g11, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElemetas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561,
    height: 319,
    viewBox: "0 0 561 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6235_2353",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 561,
    height: 319
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 561,
    height: 318.301,
    transform: "matrix(1 0 0 -1 0 318.301)",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6235_2353)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -87.6602,
    y: -30.9102,
    width: 710.466,
    height: 446.123,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M711.375 260.748C716.563 308.059 842.021 327.834 720.322 342.334C598.624 356.833 358.701 344.879 353.512 297.568C348.323 250.256 442.773 200.148 564.471 185.649C686.17 171.15 706.186 213.436 711.375 260.748Z",
    fill: "#1948B6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M666.768 290.814C671.106 330.36 760.329 348.754 674.248 359.01C588.166 369.266 417.895 355.667 413.558 316.12C409.221 276.573 475.488 236.2 561.57 225.944C647.651 215.688 662.431 251.267 666.768 290.814Z",
    fill: "#9F08B8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.795 336.902C752.983 384.214 878.44 403.989 756.742 418.488C635.044 432.987 395.121 421.034 389.932 373.722C384.743 326.41 479.193 276.303 600.891 261.803C722.59 247.304 742.606 289.59 747.795 336.902Z",
    fill: "#EB6FFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.518 324.879C538.855 364.426 488.765 387.05 428.267 394.258C367.768 401.466 339.155 382.838 334.818 343.292C330.481 303.745 376.009 265.842 436.508 258.634C497.006 251.427 530.181 285.332 534.518 324.879Z",
    fill: "#48E9FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.113 288.772C542.453 310.112 499.382 324.232 448.034 330.35C396.686 336.467 373.139 327.382 370.798 306.042C368.458 284.702 408.186 262.443 459.534 256.325C510.883 250.208 537.773 267.432 540.113 288.772Z",
    fill: "#F5FEFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.578 325.727C463.918 347.067 420.847 361.187 369.499 367.305C318.151 373.422 294.603 364.337 292.263 342.997C289.923 321.657 329.651 299.398 380.999 293.28C432.347 287.163 459.237 304.387 461.578 325.727Z",
    fill: "#F9FD4D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 -2.50586L294.705 310.556",
    stroke: "url(#paint0_linear_6235_2353)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 9.77148L294.705 322.833",
    stroke: "url(#paint1_linear_6235_2353)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 22.0508L294.705 335.112",
    stroke: "url(#paint2_linear_6235_2353)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 34.3242L294.705 347.386",
    stroke: "url(#paint3_linear_6235_2353)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 46.6035L294.705 359.665",
    stroke: "url(#paint4_linear_6235_2353)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 58.873L294.705 371.935",
    stroke: "url(#paint5_linear_6235_2353)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 71.1543L294.705 384.216",
    stroke: "url(#paint6_linear_6235_2353)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 83.4336L294.705 396.495",
    stroke: "url(#paint7_linear_6235_2353)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 95.7129L294.705 408.775",
    stroke: "url(#paint8_linear_6235_2353)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 107.986L294.705 421.048",
    stroke: "url(#paint9_linear_6235_2353)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 120.264L294.705 433.325",
    stroke: "url(#paint10_linear_6235_2353)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 132.543L294.705 445.605",
    stroke: "url(#paint11_linear_6235_2353)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 144.822L294.705 457.884",
    stroke: "url(#paint12_linear_6235_2353)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 157.096L294.705 470.157",
    stroke: "url(#paint13_linear_6235_2353)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M710.465 169.365L294.705 482.427",
    stroke: "url(#paint14_linear_6235_2353)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -205.518L-5.9043 78.7136",
    stroke: "url(#paint15_linear_6235_2353)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -194.371L-5.9043 89.8601",
    stroke: "url(#paint16_linear_6235_2353)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -183.223L-5.9043 101.009",
    stroke: "url(#paint17_linear_6235_2353)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -172.08L-5.9043 112.151",
    stroke: "url(#paint18_linear_6235_2353)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -160.93L-5.9043 123.302",
    stroke: "url(#paint19_linear_6235_2353)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -149.791L-5.9043 134.44",
    stroke: "url(#paint20_linear_6235_2353)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -138.641L-5.9043 145.591",
    stroke: "url(#paint21_linear_6235_2353)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -127.492L-5.9043 156.739",
    stroke: "url(#paint22_linear_6235_2353)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -116.346L-5.9043 167.885",
    stroke: "url(#paint23_linear_6235_2353)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -105.203L-5.9043 179.028",
    stroke: "url(#paint24_linear_6235_2353)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -94.0527L-5.9043 190.178",
    stroke: "url(#paint25_linear_6235_2353)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -82.9062L-5.9043 201.325",
    stroke: "url(#paint26_linear_6235_2353)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -71.7578L-5.9043 212.473",
    stroke: "url(#paint27_linear_6235_2353)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -60.6152L-5.9043 223.616",
    stroke: "url(#paint28_linear_6235_2353)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M371.568 -49.4746L-5.9043 234.757",
    stroke: "url(#paint29_linear_6235_2353)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.064 -16.8915C103.385 33.4447 183.695 54.4839 105.792 69.9101C27.8887 85.3363 -125.694 72.6185 -129.015 22.2823C-132.337 -28.0538 -71.8765 -81.3648 6.02649 -96.791C83.9294 -112.217 96.7426 -67.2277 100.064 -16.8915Z",
    fill: "#1948B6"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.043 6.87711C115.819 48.9522 187.087 65.7189 117.831 79.4329C48.5746 93.1469 -87.8119 84.1024 -90.5882 42.0274C-93.3646 -0.0476879 -39.472 -45.2736 29.7841 -58.9876C99.0402 -72.7016 110.267 -35.1979 113.043 6.87711Z",
    fill: "#0D0A83"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9693 328.491C61.1984 377.428 119.557 401.787 63.5377 412.88C7.51889 423.973 -103.631 404.051 -106.86 355.114C-110.089 306.177 -67.2948 257.513 -11.276 246.421C44.7428 235.328 54.7402 279.554 57.9693 328.491Z",
    fill: "#88009E"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.1 -37.9516C135.401 2.67028 76.9317 46.3537 3.28909 77.5922C-70.3535 108.831 -108.495 100.03 -119.796 59.408C-131.097 18.786 -80.5587 -39.4683 -6.91606 -70.7068C66.7266 -101.945 112.799 -78.5736 124.1 -37.9516Z",
    fill: "#00814B"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_6235_2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.948 -25.1818C32.4462 -2.4776 4.87507 12.5446 -27.9945 19.0533C-60.864 25.5621 -75.9377 15.8958 -77.4358 -6.80838C-78.934 -29.5126 -53.5024 -53.1944 -20.6328 -59.7031C12.2367 -66.2119 29.4499 -47.886 30.948 -25.1818Z",
    fill: "#F9FD4D"
  })))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M135 206.47V169.039H172.431V174.386H145.695V185.081H167.084V190.428H145.695V201.123H172.431V206.47H135Z",
    fill: "url(#paint30_linear_6235_2353)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M181.7 206.47V201.123H192.394V174.386H187.047V169.039H203.089V201.123H213.784V206.47H181.7Z",
    fill: "url(#paint31_linear_6235_2353)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M225.904 206.47V201.123H220.557V185.081H225.904V179.734H252.641V185.081H257.988V195.776H231.252V201.123H252.641V206.47H225.904ZM231.252 190.428H247.293V185.081H231.252V190.428Z",
    fill: "url(#paint32_linear_6235_2353)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M263.335 206.47V179.734H295.419V185.081H300.767V206.47H290.072V185.081H284.725V206.47H274.03V185.081H268.683V206.47H263.335Z",
    fill: "url(#paint33_linear_6235_2353)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M311.461 206.47V201.123H306.114V185.081H311.461V179.734H338.198V185.081H343.545V195.776H316.808V201.123H338.198V206.47H311.461ZM316.808 190.428H332.85V185.081H316.808V190.428Z",
    fill: "url(#paint34_linear_6235_2353)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M348.892 206.47V179.734H380.976V185.081H386.323V206.47H375.629V185.081H359.587V206.47H348.892Z",
    fill: "url(#paint35_linear_6235_2353)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M404.861 206.47V185.081H394.166V179.734H404.861V169.039H415.555V179.734H426.25V185.081H415.555V206.47H404.861Z",
    fill: "url(#paint36_linear_6235_2353)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M176.354 149.431V112H187.048V128.042H203.09V112H213.785V149.431H203.09V133.389H187.048V149.431H176.354Z",
    fill: "url(#paint37_linear_6235_2353)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M227.331 149.431V144.084H221.984V128.042H227.331V122.695H254.068V128.042H259.415V138.737H232.678V144.084H254.068V149.431H227.331ZM232.678 133.389H248.72V128.042H232.678V133.389Z",
    fill: "url(#paint38_linear_6235_2353)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M267.258 149.431V144.084H277.952V117.347H272.605V112H288.647V144.084H299.342V149.431H267.258Z",
    fill: "url(#paint39_linear_6235_2353)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M310.036 149.431V144.084H320.731V117.347H315.384V112H331.425V144.084H342.12V149.431H310.036Z",
    fill: "url(#paint40_linear_6235_2353)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M352.815 149.431V144.084H347.467V128.042H352.815V122.695H379.551V128.042H384.899V144.084H379.551V149.431H352.815ZM358.162 144.084H374.204V128.042H358.162V144.084Z",
    fill: "url(#paint41_linear_6235_2353)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6235_2353",
    x: 153.309,
    y: -17.2461,
    width: 819.965,
    height: 565.369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6235_2353",
    x: 353.357,
    y: 164.158,
    width: 418.203,
    height: 258.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6235_2353",
    x: 289.729,
    y: 158.908,
    width: 619.965,
    height: 365.369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6235_2353",
    x: 274.531,
    y: 197.662,
    width: 320.248,
    height: 258.117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_6235_2353",
    x: 310.699,
    y: 195.076,
    width: 289.504,
    height: 197.145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_6235_2353",
    x: 232.164,
    y: 232.031,
    width: 289.504,
    height: 197.145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_6235_2353",
    x: -329.146,
    y: -299.871,
    width: 668.834,
    height: 575.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_6235_2353",
    x: -150.691,
    y: -121.865,
    width: 358.693,
    height: 267.24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_6235_2353",
    x: -207.031,
    y: 144.697,
    width: 394.766,
    height: 371.17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_6235_2353",
    x: -181.375,
    y: -145.145,
    width: 366.879,
    height: 301.535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_6235_2353",
    x: -137.498,
    y: -121.033,
    width: 228.504,
    height: 202.078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_6235_2353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6235_2353",
    x1: 502.585,
    y1: -2.50586,
    x2: 502.585,
    y2: 310.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6235_2353",
    x1: 502.585,
    y1: 9.77148,
    x2: 502.585,
    y2: 322.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6235_2353",
    x1: 502.585,
    y1: 22.0508,
    x2: 502.585,
    y2: 335.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6235_2353",
    x1: 502.585,
    y1: 34.3242,
    x2: 502.585,
    y2: 347.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6235_2353",
    x1: 502.585,
    y1: 46.6035,
    x2: 502.585,
    y2: 359.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6235_2353",
    x1: 502.585,
    y1: 58.873,
    x2: 502.585,
    y2: 371.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6235_2353",
    x1: 502.585,
    y1: 71.1543,
    x2: 502.585,
    y2: 384.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6235_2353",
    x1: 502.585,
    y1: 83.4336,
    x2: 502.585,
    y2: 396.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6235_2353",
    x1: 502.585,
    y1: 95.7129,
    x2: 502.585,
    y2: 408.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6235_2353",
    x1: 502.585,
    y1: 107.986,
    x2: 502.585,
    y2: 421.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6235_2353",
    x1: 502.585,
    y1: 120.264,
    x2: 502.585,
    y2: 433.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6235_2353",
    x1: 502.585,
    y1: 132.543,
    x2: 502.585,
    y2: 445.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6235_2353",
    x1: 502.585,
    y1: 144.822,
    x2: 502.585,
    y2: 457.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6235_2353",
    x1: 502.585,
    y1: 157.096,
    x2: 502.585,
    y2: 470.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6235_2353",
    x1: 502.585,
    y1: 169.365,
    x2: 502.585,
    y2: 482.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6235_2353",
    x1: 182.832,
    y1: -205.518,
    x2: 182.832,
    y2: 78.7136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6235_2353",
    x1: 182.832,
    y1: -194.371,
    x2: 182.832,
    y2: 89.8601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6235_2353",
    x1: 182.832,
    y1: -183.223,
    x2: 182.832,
    y2: 101.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6235_2353",
    x1: 182.832,
    y1: -172.08,
    x2: 182.832,
    y2: 112.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6235_2353",
    x1: 182.832,
    y1: -160.93,
    x2: 182.832,
    y2: 123.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6235_2353",
    x1: 182.832,
    y1: -149.791,
    x2: 182.832,
    y2: 134.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6235_2353",
    x1: 182.832,
    y1: -138.641,
    x2: 182.832,
    y2: 145.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6235_2353",
    x1: 182.832,
    y1: -127.492,
    x2: 182.832,
    y2: 156.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6235_2353",
    x1: 182.832,
    y1: -116.346,
    x2: 182.832,
    y2: 167.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6235_2353",
    x1: 182.832,
    y1: -105.203,
    x2: 182.832,
    y2: 179.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6235_2353",
    x1: 182.832,
    y1: -94.0527,
    x2: 182.832,
    y2: 190.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6235_2353",
    x1: 182.832,
    y1: -82.9062,
    x2: 182.832,
    y2: 201.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6235_2353",
    x1: 182.832,
    y1: -71.7578,
    x2: 182.832,
    y2: 212.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6235_2353",
    x1: 182.832,
    y1: -60.6152,
    x2: 182.832,
    y2: 223.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6235_2353",
    x1: 182.832,
    y1: -49.4746,
    x2: 182.832,
    y2: 234.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26FF56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6235_2353",
    x1: 128.772,
    y1: 162.067,
    x2: 436.476,
    y2: 222.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6235_2353",
    x1: 128.772,
    y1: 162.067,
    x2: 436.476,
    y2: 222.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6235_2353",
    x1: 128.772,
    y1: 162.067,
    x2: 436.476,
    y2: 222.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6235_2353",
    x1: 128.772,
    y1: 162.067,
    x2: 436.476,
    y2: 222.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6235_2353",
    x1: 128.772,
    y1: 162.067,
    x2: 436.476,
    y2: 222.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6235_2353",
    x1: 128.772,
    y1: 162.067,
    x2: 436.476,
    y2: 222.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6235_2353",
    x1: 128.772,
    y1: 162.067,
    x2: 436.476,
    y2: 222.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6235_2353",
    x1: 171.894,
    y1: 105.028,
    x2: 396.298,
    y2: 136.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6235_2353",
    x1: 171.894,
    y1: 105.028,
    x2: 396.298,
    y2: 136.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6235_2353",
    x1: 171.894,
    y1: 105.028,
    x2: 396.298,
    y2: 136.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6235_2353",
    x1: 171.894,
    y1: 105.028,
    x2: 396.298,
    y2: 136.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6235_2353",
    x1: 171.894,
    y1: 105.028,
    x2: 396.298,
    y2: 136.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006C2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#90FF5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.404758,
    stopColor: "#BEFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.580106,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752368,
    stopColor: "#DDC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#687AA8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElemetas);
export default __webpack_public_path__ + "static/media/elemetas.7273ab576ce890b977f05db96651cc44.svg";
export { ForwardRef as ReactComponent };